<template>
  <div>
    <h-msg-box
      v-model="dlg_feedback"
      width="600"
      title="问题反馈"
      :mask-closable="false"
    >
      <h-form
        ref="formItem"
        cols="2"
        style="margin-top: -10px"
        :model="formItem"
        :rules="formRules"
        :label-width="1"
      >
        <h-form-item label="" prop="content" cols="2">
          <h-input
            v-model="formItem.content"
            type="textarea"
            placeholder="请输入"
            :autosize="{ minRows: 5, maxRows: 7 }"
            :maxlength="500"
            showWordLimit
          ></h-input>
        </h-form-item>
      </h-form>
      <p slot="footer">
        <h-button type="ghost" @click="fnRestCheckIn">重新填写</h-button>
        <h-button type="primary" @click="fnPostCheckIn">提交</h-button>
      </p>
    </h-msg-box>
  </div>
</template>
<script>
import { addCustomerFeedback } from "@/api/uPlusApi/";
export default {
  data() {
    return {
      dlg_feedback: false,
      formItem: {
        content: ""
      },
      formRules: {
        content: { required: true, message: "请输入反馈内容", trigger: "blur" }
      }
    };
  },
  methods: {
    openCheckIn() {
      this.dlg_feedback = true;
      this.$refs["formItem"].resetFields();
    },
    fnRestCheckIn() {
      this.$refs["formItem"].resetFields();
    },
    fnPostCheckIn() {
      this.$refs["formItem"].validate(valid => {
        if (valid) {
          this.apiAddcustomerfeedback();
        }
      });
    },
    apiAddcustomerfeedback() {
      let _param = {
        ...this.formItem
      };
      addCustomerFeedback(_param).then(res => {
        if (res.error_no == "0") {
          this.$hMessage.success("提交成功");
          this.dlg_feedback = false;
        } else {
          this.$hMessage.warning({
            content: res.error_info
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./main.scss";
</style>



// WEBPACK FOOTER //
// src/gtn/views/productSolution/compFeedback.vue